import { TITLE_REQUIRED_MESSAGE } from './constants'

const TITLE_SPECIAL_CHAR_PATTERN = /[/\\#<>&?"'`%^*=+[\]{}|!;:~@$(),]/g

const uniqueDisallowedCharsIn = (value: string): string[] => {
  const matches = value.match(TITLE_SPECIAL_CHAR_PATTERN) || []
  return [...new Set(matches)]
}

/**
 * Validates an edit-page title.
 * - Required (same rule as admin create page)
 * - Rejects special characters that break or clutter URL slugs
 */
export const validateEditPageTitle = (title: string): string | null => {
  const trimmed = title.trim()

  if (!trimmed) {
    return TITLE_REQUIRED_MESSAGE
  }

  const found = uniqueDisallowedCharsIn(trimmed)
  if (found.length > 0) {
    return `title cannot include special characters (${found.join(
      ' '
    )}). use letters, numbers, spaces, and hyphens only`
  }

  return null
}

/** Prefill errors only for special characters — not empty required. */
export const getInitialTitleError = (title: string): string => {
  const error = validateEditPageTitle(title)
  if (!error || error === TITLE_REQUIRED_MESSAGE) {
    return ''
  }
  return error
}
